import React from 'react';
import { useTranslations } from '../../hooks/useTranslations';
import { uiFullWidth, uiFullHeight } from '../../Styling/Theme/Theme';
import { Text, Title, FlexBox, Label, ResponsiveGridLayout } from '@ui5/webcomponents-react';
import { ThemingParameters } from '@ui5/webcomponents-react-base/dist';
import CrmSwitch from '@/controls/ShellPopOver/crmSwitch/CrmSwitch';

const CrmAccountSelection = () => {
    const { t } = useTranslations();
    return (
        <FlexBox
            direction="Column"
            style={{
                width: uiFullWidth.width,
                height: uiFullHeight.height,
                overflow: 'hidden',
            }}
        >
            <Title
                className="ui5-title"
                level="H5"
                style={{
                    fontSize: ThemingParameters.sapFontHeader5Size,
                    color: ThemingParameters.sapPageHeader_TextColor,
                    padding: ThemingParameters.sapContent_Margin_Medium,
                    fontWeight: '900',
                }}
            >
                {t('CUSTOMER_ACCOUNT_TITLE')}
            </Title>

            <FlexBox style={{ width: uiFullWidth.width, boxSizing: 'border-box' }}>
                <ResponsiveGridLayout
                    columnsXL={2}
                    columnsL={2}
                    columnsM={2}
                    columnsS={2}
                    className="ui5-grid-language"
                    style={{ alignItems: 'center', justifyContent: 'center', padding: ThemingParameters.sapContent_Margin_Small }}
                >
                    <Label className="ui5-text" showColon>
                        {t('CRM_ID')}
                    </Label>
                    <CrmSwitch />
                    <FlexBox
                        className="personalization"
                        direction="Column"
                        justifyContent="Start"
                        alignItems="Start"
                        style={{
                            gridColumn: 'span 2',
                            width: '100%',
                            textAlign: 'left',
                            marginBottom: '0',
                        }}
                    >
                        <Text
                            className="ui5-text"
                            style={{
                                ...uiFullWidth,
                                fontSize: ThemingParameters.sapFontSize,
                                color: ThemingParameters.sapContent_LabelColor,
                                padding: ThemingParameters.sapContent_Margin_Small,
                                textAlign: 'left',
                            }}
                        >
                            {t('CRM_CLARIFICATION')}
                        </Text>
                    </FlexBox>
                    <FlexBox
                        direction="Column"
                        className="footer"
                        style={{ gridColumn: 'span 2', marginTop: ThemingParameters.sapContent_Margin_Small }}
                    >
                        <hr
                            style={{
                                ...uiFullWidth,
                                borderTop: 'none',
                                borderColor: `${ThemingParameters.sapGroup_ContentBorderColor}`,
                                borderWidth: '2px',
                            }}
                        />
                        <Text
                            style={{
                                color: ThemingParameters.sapContent_LabelColor,
                                fontStyle: 'italic',
                                fontWeight: '400',
                                gridColumn: 'span 2',
                                fontSize: ThemingParameters.sapFontSmallSize,
                                marginTop: ThemingParameters.sapContent_Margin_Small,
                            }}
                        >
                            {t('SAVE_SETTING_MESSAGE')}
                        </Text>
                    </FlexBox>
                </ResponsiveGridLayout>
            </FlexBox>
        </FlexBox>
    );
};

export default CrmAccountSelection;
